import r from "react";
const c = "_fuseDivider_1sjee_1", l = "_fuseDivider--size-xs_1sjee_8", n = "_fuseDivider--size-s_1sjee_12", a = "_fuseDivider--size-m_1sjee_16", m = "_fuseDivider--size-l_1sjee_20", S = "_fuseDivider--size-xl_1sjee_24", e = {
  fuseDivider: c,
  "fuseDivider--size-xs": "_fuseDivider--size-xs_1sjee_8",
  fuseDividerSizeXs: l,
  "fuseDivider--size-s": "_fuseDivider--size-s_1sjee_12",
  fuseDividerSizeS: n,
  "fuseDivider--size-m": "_fuseDivider--size-m_1sjee_16",
  fuseDividerSizeM: a,
  "fuseDivider--size-l": "_fuseDivider--size-l_1sjee_20",
  fuseDividerSizeL: m,
  "fuseDivider--size-xl": "_fuseDivider--size-xl_1sjee_24",
  fuseDividerSizeXl: S
}, { forwardRef: j } = r, x = j(({ color: i, className: d, dataTestId: f, size: s = "xs", tag: v = "div", ...u }, _) => {
  const D = v, t = s ? e[`fuseDivider--size-${s}`] : e["fuseDivider--size-xs"], z = `${e.fuseDivider} ${t} fuse-divider ${d || ""}`.trim(), o = i ? { borderBottomColor: i } : {};
  return r.createElement(D, {
    className: z,
    "data-testid": f || "fuse-divider",
    ref: _,
    style: o,
    ...u
  });
});
x.displayName = "Divider";
export {
  x as Divider
};
